import { gql, useMutation } from '@apollo/client'

const MUTATION_USER_KYC_REMOVE_ALL = gql`
  mutation UserKycRemoveAll($input: UserKycRemoveAllInput!) {
    userKycRemoveAll(input: $input) {
      deletedCount
    }
  }
`

export interface MutationUserKycRemoveAllInput {
  input: {
    userId: number
  }
}

export interface MutationUserKycRemoveAllPayload {
  userKycRemoveAll: {
    deletedCount: number
  }
}

const useUserKycRemoveAllMutation = () => {
  return useMutation<
    { userKycRemoveAll: MutationUserKycRemoveAllPayload },
    MutationUserKycRemoveAllInput
  >(MUTATION_USER_KYC_REMOVE_ALL)
}

export default useUserKycRemoveAllMutation
